<template>
  <div :class="$style.Container">
    <div :class="$style.Title">POD印花裂变工具</div>
    <div :class="$style.Des"
      >采集/裂变/抠图/套版，都是 <span style="font-weight: bold">批量！</span></div
    >
    <div :class="$style.Btn" @click="handleGo">去看看</div>
    <img
      :class="$style.Image"
      src="https://static.lingvisions.com/public/fe5d364fd392490e9ad3f83ff0d27047.png"
    />
  </div>
</template>

<script setup lang="ts">
  function handleGo() {
    window.open('/aiad/batch/dashboard');
  }
</script>

<style lang="less" module>
  .Container {
    width: 472px;
    height: 120px;
    border-radius: 16px;
    background-color: rgba(34, 88, 73, 1);
    padding-top: 16px;
    padding-left: 24px;
    overflow: hidden;
  }

  .Title {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
  }

  .Des {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.85);
  }

  .Btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 114px;
    height: 32px;
    margin-top: 8px;
    background-color: rgba(20, 20, 20, 1);
    cursor: pointer;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.85);
    border-radius: 6px;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(209, 108, 68, 1);
    }
  }

  .Image {
    position: absolute;
    top: 0;
    right: 0;
    width: 190px;
    height: 120px;
  }
</style>
